import * as React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import NotesList from 'modules/notes/components/list/NotesList';

import SidePanel from './SidePanel';
import SidePanelHeader from './SidePanelHeader';
import SidePanelTabs from './SidePanelTabs';

import { t } from 'utils/language';
import { BRAND } from 'utils/brands';
import { fetchNotes, resetNotes } from 'modules/notes/reducers/notes';

import type { Campaign, Subcampaign } from 'types';

import type { SyntheticEvent } from 'react';

type OwnProps = {
  campaign: Campaign,
  subcampaign: Subcampaign,
  onClosePanel: () => void,
  onCloseAllPanels: () => void
};

type DispatchProps = {
  dispatchFetchNotes: (influencerId: number) => void,
  dispatchResetNotes: () => void
};

type Props = OwnProps & DispatchProps;

type State = {
  activeTab: string
};

const TAB_ITEMS = ['campaign', 'creator'];

class SidePanelNotes extends React.Component<Props, State> {
  state: State = {
    activeTab: TAB_ITEMS[0]
  };

  componentDidMount() {
    const { subcampaign, dispatchFetchNotes } = this.props;
    const influencerId = subcampaign.creatorProfile.id;

    dispatchFetchNotes(influencerId);
  }

  componentDidUpdate(prevProps: Props) {
    const { subcampaign, dispatchFetchNotes } = this.props;
    const influencerId = subcampaign.creatorProfile.id;

    if (influencerId !== get(prevProps, 'subcampaign.creatorProfile.id')) {
      dispatchFetchNotes(influencerId);
    }
  }

  componentWillUnmount() {
    const { dispatchResetNotes } = this.props;
    dispatchResetNotes();
  }

  changeActiveTab = (e: SyntheticEvent<HTMLSpanElement>) => {
    const activeTab = e.currentTarget.dataset.arg;
    if (!activeTab) {
      return;
    }

    this.setState({
      activeTab
    });
  };

  render() {
    const { campaign, subcampaign, onClosePanel, onCloseAllPanels } = this.props;
    const { activeTab } = this.state;
    const influencerId = subcampaign.creatorProfile.id;

    return (
      <SidePanel>
        <div className="side-panel-notes">
          <SidePanelHeader
            title={t('messenger.side_panel.creator_notes_title')}
            onClosePanel={onClosePanel}
            onCloseAllPanels={onCloseAllPanels}
          />
          <SidePanelTabs
            tabs={TAB_ITEMS}
            activeTab={activeTab}
            handleChangeActiveTab={this.changeActiveTab}
          />
          <div className="side-panel-links__content">
            <NotesList
              key={influencerId}
              campaignId={campaign.id}
              context={activeTab}
              influencerProfileId={subcampaign.creatorProfile.id}
            />
          </div>
        </div>
      </SidePanel>
    );
  }
}

const mapDispatchToProps = (dispatch, { campaign }): DispatchProps => ({
  dispatchFetchNotes: (influencerId) => {
    dispatch(fetchNotes(influencerId, BRAND));
    dispatch(fetchNotes(influencerId, BRAND, campaign.id));
  },

  dispatchResetNotes: () => dispatch(resetNotes())
});

export default connect(null, mapDispatchToProps)(SidePanelNotes);
